export default __webpack_public_path__ + "static/media/owl-eyes.5697c0a9.png";